var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (ViewHelpers, artworkColumns, buttonLabel, numberOfColumns, seeMore, undefined) {
// iterate artworkColumns
;(function(){
  var $$obj = artworkColumns;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var column = $$obj[$index];

buf.push("<div class=\"artwork-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<figure" + (jade.attr("data-artwork", artwork.id, true, true)) + (jade.attr("data-id", artwork._id, true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-image-link\">");
if ( artwork.image)
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (ViewHelpers.factor(artwork.image) * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", artwork.image.url, true, true)) + (jade.attr("nopin", ViewHelpers.noPinAttr(artwork), true, true)) + (jade.attr("alt", ViewHelpers.toAltText(artwork), true, true)) + "></div>");
}
buf.push("<div class=\"overlay-container\"><div class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = ViewHelpers.titleAndYear(artwork)) ? "" : jade_interp) + "</p>");
if ( artwork.partner)
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partner.href)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( artwork.sale_message != 'Contact For Price')
{
buf.push("<p class=\"artwork-item-sale-price\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</p>");
}
if ( artwork.is_inquireable)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<figure" + (jade.attr("data-artwork", artwork.id, true, true)) + (jade.attr("data-id", artwork._id, true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-image-link\">");
if ( artwork.image)
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (ViewHelpers.factor(artwork.image) * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", artwork.image.url, true, true)) + (jade.attr("nopin", ViewHelpers.noPinAttr(artwork), true, true)) + (jade.attr("alt", ViewHelpers.toAltText(artwork), true, true)) + "></div>");
}
buf.push("<div class=\"overlay-container\"><div class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = ViewHelpers.titleAndYear(artwork)) ? "" : jade_interp) + "</p>");
if ( artwork.partner)
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partner.href)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( artwork.sale_message != 'Contact For Price')
{
buf.push("<p class=\"artwork-item-sale-price\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</p>");
}
if ( artwork.is_inquireable)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var column = $$obj[$index];

buf.push("<div class=\"artwork-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<figure" + (jade.attr("data-artwork", artwork.id, true, true)) + (jade.attr("data-id", artwork._id, true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-image-link\">");
if ( artwork.image)
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (ViewHelpers.factor(artwork.image) * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", artwork.image.url, true, true)) + (jade.attr("nopin", ViewHelpers.noPinAttr(artwork), true, true)) + (jade.attr("alt", ViewHelpers.toAltText(artwork), true, true)) + "></div>");
}
buf.push("<div class=\"overlay-container\"><div class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = ViewHelpers.titleAndYear(artwork)) ? "" : jade_interp) + "</p>");
if ( artwork.partner)
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partner.href)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( artwork.sale_message != 'Contact For Price')
{
buf.push("<p class=\"artwork-item-sale-price\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</p>");
}
if ( artwork.is_inquireable)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<figure" + (jade.attr("data-artwork", artwork.id, true, true)) + (jade.attr("data-id", artwork._id, true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-image-link\">");
if ( artwork.image)
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (ViewHelpers.factor(artwork.image) * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", artwork.image.url, true, true)) + (jade.attr("nopin", ViewHelpers.noPinAttr(artwork), true, true)) + (jade.attr("alt", ViewHelpers.toAltText(artwork), true, true)) + "></div>");
}
buf.push("<div class=\"overlay-container\"><div class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.public)
{
buf.push("<a" + (jade.attr("href", artist.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = ViewHelpers.titleAndYear(artwork)) ? "" : jade_interp) + "</p>");
if ( artwork.partner)
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partner.href)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = ViewHelpers.partnerName(artwork)) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( artwork.sale_message != 'Contact For Price')
{
buf.push("<p class=\"artwork-item-sale-price\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</p>");
}
if ( artwork.is_inquireable)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-item-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  }
}).call(this);

if ( numberOfColumns)
{
for (var i = 0; i < numberOfColumns; i++)
{
buf.push("<div class=\"artwork-column\"></div>");
}
}
if ( seeMore)
{
buf.push("<button class=\"avant-garde-button-text artwork-columns-see-more\">" + (jade.escape(null == (jade_interp = buttonLabel) ? "" : jade_interp)) + "</button>");
}}.call(this,"ViewHelpers" in locals_for_with?locals_for_with.ViewHelpers:typeof ViewHelpers!=="undefined"?ViewHelpers:undefined,"artworkColumns" in locals_for_with?locals_for_with.artworkColumns:typeof artworkColumns!=="undefined"?artworkColumns:undefined,"buttonLabel" in locals_for_with?locals_for_with.buttonLabel:typeof buttonLabel!=="undefined"?buttonLabel:undefined,"numberOfColumns" in locals_for_with?locals_for_with.numberOfColumns:typeof numberOfColumns!=="undefined"?numberOfColumns:undefined,"seeMore" in locals_for_with?locals_for_with.seeMore:typeof seeMore!=="undefined"?seeMore:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;